module.exports = __webpack_public_path__ + "2a38dda871a72d9c9f8b7764d55a67b3.svg";